import {
  QuestionGroupSortAttribute,
  QuestionGroupSortInput,
  SortDirection
} from '@generated/base-types';
import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { TaskQuestionGroup } from '../../../lib/types';

export interface TaskQuestionGroupsStateModel {
  items: EntityData<TaskQuestionGroup[]>;
  selectedIds: string[];
  sortAttributes: QuestionGroupSortInput[];
}

export const taskQuestionGroupsStateDefaults: TaskQuestionGroupsStateModel = {
  items: initialEntityData(),
  selectedIds: [],
  sortAttributes: [
    {
      attribute: QuestionGroupSortAttribute.SequentialNumber,
      direction: SortDirection.Asc
    }
  ]
};
